import React from "react";
import { Link } from "react-router-dom";

// Logo assets ship from /public so they are version-aware with the deploy.
// `desktop-logo.png` — horizontal lockup (shield + GuestIntel wordmark + "Know Ahead.")
// `mobile-logo.png`  — stacked vertical lockup for tight spaces / mobile bars
// `app-icon-logo.png`— square shield only, used as iOS/Android app icon
const DESKTOP_LOGO = "/desktop-logo.png";
const MOBILE_LOGO  = "/mobile-logo.png";
const ICON_LOGO    = "/app-icon-logo.png";

export const LOGO_URL = DESKTOP_LOGO;

/**
 * GuestIntel logo.
 * Variants:
 *   sm  — 28px height (mobile top bars, footers)
 *   md  — 40px height (sidebar, page headers — default)
 *   lg  — 64px height (in-app hero, splash)
 *   xl  — 88px height (marketing nav, landing page)
 *   2xl — 120px height (footer / hero on landing)
 *
 * Pass `variant="icon"` for the square shield only (favicon, profile pics).
 * Pass `variant="stacked"` for the vertical mobile lockup.
 */
export default function Logo({ size = "md", to, className = "", testid = "logo", variant = "horizontal" }) {
  const sizes = {
    sm: "h-7",
    md: "h-10",
    lg: "h-16",
    xl: "h-[88px]",
    "2xl": "h-[120px]",
  };
  const src = variant === "icon" ? ICON_LOGO : variant === "stacked" ? MOBILE_LOGO : DESKTOP_LOGO;
  const cls = `${sizes[size] || sizes.md} w-auto select-none object-contain ${className}`;
  const img = (
    <img
      src={src}
      alt="GuestIntel — Know Ahead."
      className={cls}
      draggable={false}
      data-testid={testid}
    />
  );
  if (to) {
    return (
      <Link to={to} className="inline-flex items-center" data-testid={`${testid}-link`}>
        {img}
      </Link>
    );
  }
  return img;
}
